import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

export const plantillasRoutes: Routes = [
  {
    path: 'plantillas',
    canActivate: [permisoGuard],
    data: { permiso: [Permiso.PLANTILLAS_VER, Permiso.PLANTILLAS_EDITAR] },
    loadComponent: () => import('./pages/plantillas/plantillas.page').then((m) => m.PlantillasPage),
    title: 'SiLabVet | Plantillas de documento',
  },
  {
    path: 'plantillas/encabezado-pie',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.PLANTILLAS_ENCABEZADO },
    loadComponent: () =>
      import('./pages/encabezado-pie/encabezado-pie.page').then((m) => m.EncabezadoPiePage),
    title: 'SiLabVet | Encabezado y pie',
  },
  {
    path: 'plantillas/:codigo/editar',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.PLANTILLAS_EDITAR },
    loadComponent: () =>
      import('./pages/plantilla-editor/plantilla-editor.page').then((m) => m.PlantillaEditorPage),
    title: 'SiLabVet | Diseñar plantilla',
  },
];
